/* React */
import React from "react";

/* Ionic */
import { IonInput } from "@ionic/react";

/* Components */
import FilterLabel from "src/components/shared/labels/filter-label/FilterLabel";

/* Stylesheet */
import styles from "./SimpleInput.module.scss";

/* Interfaces */
import { BasicErrorProps } from "src/shared/interfaces/error/Error";

interface SimpleInputProps {
  scssProps?: ScssProps;
  label?: string;
  type: "text";
  value: string;
  placeholder: string;
  disabled: boolean;
  onChange: (value: string) => void;
  error?: BasicErrorProps;
  clearError: () => void;
}

interface ScssProps {
  margin?: string;
}

const SimpleInput: React.FC<SimpleInputProps> = ({
  scssProps,
  label,
  type,
  value,
  placeholder,
  disabled,
  onChange,
  error,
  clearError,
}) => {
  return (
    <div
      style={{ margin: scssProps?.margin }}
      className={styles.simple_input}
    >
      {label ? (
        <FilterLabel
          label={label}
          scssProps={{
            color: "var(--ion-color-text-primary)",
          }}
        />
      ) : undefined}
      <IonInput
        style={{
          color: error
            ? "var(--ion-color-error)"
            : disabled
            ? "var(--ion-color-text-disabled)"
            : undefined,
          border: error
            ? "1px solid var(--ion-color-error)"
            : "transparent",
        }}
        className={`${styles.input} input`}
        type={type}
        placeholder={placeholder}
        value={value}
        // Ensure the input doesn't exceed a certain length of characters
        maxlength={50}
        disabled={disabled}
        onIonInput={(e: CustomEvent) => {
          onChange(e.detail?.value);
          clearError();
        }}
      />
      {error ? (
        <div className={styles.error_container}>
          <div className={styles.message}>
            {error.message}
          </div>
        </div>
      ) : undefined}
    </div>
  );
};

export default SimpleInput;
